import { UserCreateRequest, UserActions, Role, User } from "../domain/user";
import { createUserService } from "../infrastructure/services/createUserService";
import { tokenValidation } from "@/business/auth/application/tokenValidation";

export const createUser = {
  async execute(
    name: string,
    username: string,
    role: string,
    emplid: string,
    base_price: string,
    password: string,
    email: string,
    rol: Role
  ): Promise<User> {
    const request: UserCreateRequest = await UserActions().createUserRequest(
      name,
      username,
      role,
      emplid,
      base_price,
      password,
      email
    );
    await createUserService.execute(await tokenValidation.execute(), request);
    return UserActions().createUser(
      request.name,
      request.username,
      rol,
      request.emplid,
      request.base_price,
      null,
      request.email
    );
  },
};


